// ============================================================================
// noteData.js — a cetli-dokumentumok átalakítása és rendezése (2026-10-07).
// Külön, tiszta modul, hogy tesztelhető legyen (mint a roomData.js).
// ============================================================================

/** Firestore Timestamp / ezredmásodperc -> ezredmásodperc (0, ha nincs). */
export function idopontMs(ts) {
  if (ts && typeof ts.toMillis === "function") return ts.toMillis();
  if (ts && typeof ts.seconds === "number") return ts.seconds * 1000;
  return typeof ts === "number" ? ts : 0;
}

/** Egy Firestore-dokumentumból a kliens cetli-objektuma. */
export function cetliDokumentumbol(noteId, data) {
  const d = data || {};
  const szoveg = (v) => (typeof v === "string" ? v : "");
  return {
    noteId,
    fromUid: szoveg(d.fromUid),
    // A küldő nevének írásmód-változatai: ugyanazok a mezők, mint az üzeneteken, így a
    // chatView.feladoNev ugyanúgy használható.
    senderName: szoveg(d.senderName),
    senderNameLatn: szoveg(d.senderNameLatn),
    senderNameJa: szoveg(d.senderNameJa),
    senderNameZh: szoveg(d.senderNameZh),
    senderNameKo: szoveg(d.senderNameKo),
    senderNameCyr: szoveg(d.senderNameCyr),
    senderNameEl: szoveg(d.senderNameEl),
    text: szoveg(d.text),
    sourceLang: typeof d.sourceLang === "string" && d.sourceLang ? d.sourceLang : null,
    translatedText: szoveg(d.translatedText) || null,
    translatedLang: typeof d.translatedLang === "string" && d.translatedLang ? d.translatedLang : null,
    createdAt: idopontMs(d.createdAt),
    expireAt: idopontMs(d.expireAt),
  };
}

/**
 * A megjelenítendő cetlik: a lejártak (a Firestore TTL-törlés akár egy napot késhet) kimaradnak,
 * legújabb elöl, legfeljebb `max` darab (a szerver is 5-nél tart, ez védőháló).
 */
export function megjelenitendoCetlik(cetlik, now = Date.now(), max = 5) {
  return [...cetlik]
    .filter((c) => c && c.text && !(c.expireAt && c.expireAt < now))
    .sort((a, b) => b.createdAt - a.createdAt || (a.noteId < b.noteId ? 1 : -1))
    .slice(0, max);
}
